// extracted by mini-css-extract-plugin
export default {"summary":"WatchedSummary_summary__Wj87F","summary-title":"WatchedSummary_summary-title__+8F7Y","summary-statics":"WatchedSummary_summary-statics__V1Pff"};